import "@fontsource-variable/mulish/index.css";
import { ChakraProvider } from "@chakra-ui/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import theme from "./Theme";
import { AuthProvider } from "./context/Authentication";
import { TableViewProvider } from "./context/TableView";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      networkMode: "always",
    },
    mutations: {
      networkMode: "always",
    },
  },
});

function Providers({ children }: React.PropsWithChildren) {
  return (
    <ChakraProvider value={theme}>
      <AuthProvider>
        <TableViewProvider>
          <QueryClientProvider client={queryClient}>
            {children}
          </QueryClientProvider>
        </TableViewProvider>
      </AuthProvider>
    </ChakraProvider>
  );
}

export default Providers;
